import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKCARTPAGE_LEGACY_FIELD_ORDER = [
  "title",
  "background_color",
  "background_image",
  "text_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskCartPageDescriptor: _generatedKioskCartPageDescriptor,
  kioskCartPageBlocDefinition,
  kioskCartPageDashboardLayout,
  kioskCartPageConfig,
  kioskCartPageResolveConfig,
  kioskCartPageProperties,
} = doodBlockConfig(
  {
    name: "Kiosk - Cart page",
    internal_name: "Kiosk - Cart page",
    url: "cart",
    defaultParent: [/^Main Layout$/i],
    componentType: 'KioskCartPageComponent',
    category: 'page',
    description: "Kiosk - Cart page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'header',
        name: "pages.blocks.kiosk-cart-page.header.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskHeaderBlock"],
        slotItemFormat: 'ids',
        defaultBlocks: [
          { id: 'kiosk-header-block', type: 'KioskHeaderBlockComponent' },
        ],
      },
      {
        key: 'body',
        name: "pages.blocks.kiosk-cart-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskCartProductsListBlock", "KioskCartPromoCodeBlock", "KioskCartLoyaltyBlock", "KioskCartRecommendationCardsBlock", "MosaicBlock", "ImageFullWidthBlock", "ImageAndTextBlock", "SpacerBlock", "ZerosixAssetListBlock", "PongoAssetListBlock", "ComoAssetListBlock"],
        slotItemFormat: 'ids',
        defaultBlocks: [
          { id: 'kiosk-cart-products-list-block', type: 'KioskCartProductsListBlockComponent' },
          { id: 'kiosk-cart-promo-code-block', type: 'KioskCartPromoCodeBlockComponent' },
          { id: 'kiosk-cart-loyalty-block', type: 'KioskCartLoyaltyBlockComponent' },
          { id: 'kiosk-cart-recommendation-cards-block', type: 'KioskCartRecommendationCardsBlockComponent' },
        ],
      },
      {
        key: 'footer',
        name: "pages.blocks.kiosk-cart-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskCartFooterBlock"],
        slotItemFormat: 'ids',
        defaultBlocks: [
          { id: 'kiosk-cart-footer-block', type: 'KioskCartFooterBlockComponent' },
        ],
      }
    ]
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-page.title.label",
      }
    }),
    primary_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-page.primary-button-background-color.label",
      }
    }),
    primary_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-cart-page.primary-button-text-color.label",
      }
    }),
    secondary_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-cart-page.secondary-button-background-color.label",
      }
    }),
    secondary_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-page.secondary-button-text-color.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.kiosk-cart-page.background-color.label",
      }
    }),
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-page.background-image.label",
        help: "pages.blocks.kiosk-cart-page.background-image.help",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#000"},
      options: {
        label: "pages.blocks.kiosk-cart-page.text-color.label",
      }
    })
  }),

  () => ({
    omitFields: [
      "primary_button_background_color",
      "primary_button_text_color",
      "secondary_button_background_color",
      "secondary_button_text_color",
    ] as const,
    tabs: [
      {
        label: "pages.blocks.kiosk-cart-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-cart-page.fieldset.header.label",
            fields: ["header"],
          },
          {
            legend: "pages.blocks.kiosk-cart-page.fieldset.title.label",
            fields: ["title"],
          },
          {
            legend: "pages.blocks.kiosk-cart-page.fieldset.page.label",
            fields: ["background_color", "background_image", "text_color"],
          },
          {
            legend: "pages.blocks.kiosk-cart-page.fieldset.body.label",
            fields: ["body"],
          },
          {
            legend: "pages.blocks.kiosk-cart-page.fieldset.footer.label",
            fields: ["footer"],
          },
        ],
      },
    ],
  })
);

export function kioskCartPageDescriptor(): IBlockDescriptor;
export function kioskCartPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskCartPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskCartPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskCartPageDescriptor, kioskCartPageProperties, fieldOrder);
}

export {
  kioskCartPageBlocDefinition,
  kioskCartPageDashboardLayout,
  kioskCartPageProperties,
  kioskCartPageConfig,
  kioskCartPageResolveConfig,
};

export type KioskCartPageConfig = typeof kioskCartPageConfig;
